// extracted by mini-css-extract-plugin
module.exports = {"root":"TypesOfLogoForm_root__3yySW"};